import { j as e } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { memo as s } from "react";
const l = s(({
  activationType: i,
  role: n
}) => {
  switch (i) {
    case "DIRECT":
      return n === "publisher" ? /* @__PURE__ */ e.jsxs("span", { style: {
        fontSize: "0.875em",
        lineHeight: "1rem"
      }, children: [
        "The file should include a",
        " ",
        /* @__PURE__ */ e.jsx("span", { style: {
          fontWeight: 500
        }, children: "Activation ID" }),
        " column and a",
        " ",
        /* @__PURE__ */ e.jsx("span", { style: {
          fontWeight: 500
        }, children: "Matching ID" }),
        " column"
      ] }) : n === "advertiser" ? /* @__PURE__ */ e.jsxs("span", { style: {
        fontSize: "0.875em",
        lineHeight: "1rem"
      }, children: [
        "The file should include a",
        " ",
        /* @__PURE__ */ e.jsx("span", { style: {
          fontWeight: 500
        }, children: "Matching ID" }),
        " column and a",
        " ",
        /* @__PURE__ */ e.jsx("span", { style: {
          fontWeight: 500
        }, children: "Advertiser audience" }),
        " column"
      ] }) : null;
    case "CONSENTLESS":
      return n === "publisher" ? /* @__PURE__ */ e.jsxs("span", { style: {
        fontSize: "0.875em",
        lineHeight: "1rem"
      }, children: [
        "The file should include a",
        " ",
        /* @__PURE__ */ e.jsx("span", { style: {
          fontWeight: 500
        }, children: "Matching ID" }),
        " column and a",
        " ",
        /* @__PURE__ */ e.jsx("span", { style: {
          fontWeight: 500
        }, children: "Segment" }),
        " column"
      ] }) : n === "advertiser" ? /* @__PURE__ */ e.jsxs("span", { style: {
        fontSize: "0.875em",
        lineHeight: "1rem"
      }, children: [
        "The file should include a",
        " ",
        /* @__PURE__ */ e.jsx("span", { style: {
          fontWeight: 500
        }, children: "Matching ID" }),
        " column and a",
        " ",
        /* @__PURE__ */ e.jsx("span", { style: {
          fontWeight: 500
        }, children: "Advertiser audience" }),
        " column"
      ] }) : null;
    case null:
      return /* @__PURE__ */ e.jsxs("span", { style: {
        fontSize: "0.875em",
        lineHeight: "1rem"
      }, children: [
        "The file should include a",
        " ",
        /* @__PURE__ */ e.jsx("span", { style: {
          fontWeight: 500
        }, children: "Matching ID" }),
        " column"
      ] });
    default:
      return null;
  }
});
l.displayName = "FileRequirements";
export {
  l as default
};
//# sourceMappingURL=FileRequirements.js.map
